import React, { PureComponent } from "react";
import { PropTypes } from "prop-types";
import { Table, Icon } from "semantic-ui-react";

import { MediaAs } from "../../styles/Media.js";

import ActionDropdownMenu from "../actionDropdownMenu/ActionDropdownMenu.jsx";
import ResourceMarker from "../marking/ResourceMarker.jsx";
import LinkWithReset from "../utils/LinkWithReset.jsx";

import { USER_RESOURCE_KEYS } from "../../constants/entity.js";

class ProjectRow extends PureComponent {
  static propTypes = {
    project: PropTypes.object.isRequired,
    disabled: PropTypes.bool,
    onDelete: PropTypes.func.isRequired
  };

  // -- HANDLERS -- //

  handleDelete = () => {
    const { onDelete, project } = this.props;
    onDelete(project["@id"]);
  };

  // -- RENDER -- //

  renderResource = resourceKey => {
    const { project } = this.props;

    if (project.hasOwnProperty(resourceKey)) {
      return (
        <MediaAs
          greaterThan="smallTablet"
          collapsing
          key={`${project["@id"]}-${resourceKey}`}
          as={Table.Cell}
        >
          {project[resourceKey].length}
        </MediaAs>
      );
    }

    return null;
  };

  renderResources = () => {
    return USER_RESOURCE_KEYS.map(key => {
      return this.renderResource(key);
    });
  };

  render() {
    const { project, copy } = this.props;

    return (
      <Table.Row key={project.id} textAlign="center">
        <Table.Cell textAlign="left">
          <LinkWithReset to={project["@id"]} className="table-link">
            <Icon name="folder" /> {project.name}
          </LinkWithReset>
        </Table.Cell>

        {this.renderResources()}

        <Table.Cell collapsing>
          <ActionDropdownMenu
            viewPath={project["@id"]}
            onDelete={this.handleDelete}
            data={project}
            copy={copy("project_dropdown_menu")}
          />
        </Table.Cell>
        <Table.Cell verticalAlign="middle" collapsing>
          <ResourceMarker
            marking={project.marking}
            circular={true}
            style={{ display: "block" }}
          />
        </Table.Cell>
      </Table.Row>
    );
  }
}

export default ProjectRow;
